require('@geoblocks/proj/src/EPSG_21781.js')
require('angular')
require('angular-animate')
require('angular-dynamic-locale')
require('angular-gettext')
require('angular-sanitize')
require('angular-touch')
require('angular-ui-date')
require('angular-ui-slider')
require('bootstrap/js/src/alert.js')
require('bootstrap/js/src/collapse.js')
require('bootstrap/js/src/dropdown.js')
require('bootstrap/js/src/modal.js')
require('bootstrap/js/src/popover.js')
require('bootstrap/js/src/tooltip.js')
require('d3')
require('file-saver')
require('floatthead')
require('jquery')
require('jquery-datetimepicker/jquery.datetimepicker.js')
require('jquery-ui-touch-punch')
require('jquery-ui/ui/i18n/datepicker-de.js')
require('jquery-ui/ui/i18n/datepicker-en-GB.js')
require('jquery-ui/ui/i18n/datepicker-fr.js')
require('jquery-ui/ui/i18n/datepicker-it.js')
require('jquery-ui/ui/widgets/draggable.js')
require('jquery-ui/ui/widgets/resizable.js')
require('jquery-ui/ui/widgets/slider.js')
require('jquery-ui/ui/widgets/sortable.js')
require('localforage/src/localforage.js')
require('ol/Collection.js')
require('ol/Feature.js')
require('ol/Geolocation.js')
require('ol/Map.js')
require('ol/MapBrowserPointerEvent.js')
require('ol/Observable.js')
require('ol/Overlay.js')
require('ol/OverlayPositioning.js')
require('ol/View.js')
require('ol/array.js')
require('ol/color.js')
require('ol/control/Control.js')
require('ol/control/MousePosition.js')
require('ol/control/Rotate.js')
require('ol/control/ScaleLine.js')
require('ol/control/Zoom.js')
require('ol/coordinate.js')
require('ol/dom.js')
require('ol/easing.js')
require('ol/events.js')
require('ol/events/Event.js')
require('ol/events/Target.js')
require('ol/events/condition.js')
require('ol/extent')
require('ol/extent.js')
require('ol/format/Feature.js')
require('ol/format/GML2.js')
require('ol/format/GML3.js')
require('ol/format/GPX.js')
require('ol/format/GeoJSON.js')
require('ol/format/KML.js')
require('ol/format/TextFeature.js')
require('ol/format/WFS.js')
require('ol/format/WMSCapabilities.js')
require('ol/format/WMSGetFeatureInfo.js')
require('ol/format/WMTSCapabilities.js')
require('ol/format/XML.js')
require('ol/format/filter.js')
require('ol/functions.js')
require('ol/geom/Circle.js')
require('ol/geom/Geometry.js')
require('ol/geom/GeometryCollection.js')
require('ol/geom/GeometryLayout.js')
require('ol/geom/LineString.js')
require('ol/geom/LinearRing.js')
require('ol/geom/MultiLineString.js')
require('ol/geom/MultiPoint.js')
require('ol/geom/MultiPolygon.js')
require('ol/geom/Point.js')
require('ol/geom/Polygon.js')
require('ol/geom/SimpleGeometry.js')
require('ol/has.js')
require('ol/interaction.js')
require('ol/interaction/DragBox.js')
require('ol/interaction/Draw.js')
require('ol/interaction/Interaction.js')
require('ol/interaction/Modify.js')
require('ol/interaction/Pointer.js')
require('ol/interaction/Snap.js')
require('ol/interaction/Translate.js')
require('ol/layer/Base.js')
require('ol/layer/Group.js')
require('ol/layer/Image.js')
require('ol/layer/Layer.js')
require('ol/layer/Tile.js')
require('ol/layer/Vector.js')
require('ol/math.js')
require('ol/obj.js')
require('ol/proj.js')
require('ol/size.js')
require('ol/source/Image.js')
require('ol/source/ImageWMS.js')
require('ol/source/Tile.js')
require('ol/source/TileWMS.js')
require('ol/source/Vector.js')
require('ol/source/WMTS.js')
require('ol/sphere.js')
require('ol/string.js')
require('ol/structs/RBush.js')
require('ol/style/Circle.js')
require('ol/style/Fill.js')
require('ol/style/Icon.js')
require('ol/style/RegularShape.js')
require('ol/style/Stroke.js')
require('ol/style/Style.js')
require('ol/style/Text.js')
require('ol/tilegrid.js')
require('ol/tilegrid/TileGrid.js')
require('ol/tilegrid/WMTS.js')
require('ol/uri.js')
require('ol/util.js')
require('ol/xml.js')
